// src/components/Footer.jsx
import React from "react";
import {
  SiDiscord,
  SiFacebook,
  SiX,
  SiYoutube,
  SiInstagram,
  SiReddit,
  SiLinkedin,
  SiKickstarter,
  SiTiktok,
  SiBluesky,
} from "react-icons/si";
import themeColors from "../themeColors";
import BrandName from "./BrandName";

const socialLinks = [
  { icon: SiDiscord, url: "https://discord.gg/TdPsv5xujp", name: "Discord", color: "#5865F2" },
  { icon: SiFacebook, url: "https://www.facebook.com/profile.php?id=61577779259038", name: "Facebook", color: "#1877F2" },
  { icon: SiX, url: "https://x.com/TwinFrameGames", name: "X", color: "#1DA1F2" },
  { icon: SiBluesky, url: "https://bsky.app/profile/twinframestudios.bsky.social", name: "BlueSky", color: "#1DA1F2" },
  { icon: SiYoutube, url: "https://youtube.com/@twinframe_studios?si=icQ_npWmbr65MY-V", name: "YouTube", color: "#FF0000" },
  //{ icon: SiInstagram, url: "https://www.instagram.com/twinframestudios/", name: "Instagram", color: "#E1306C" },
  { icon: SiTiktok, url: "https://www.tiktok.com/@twinframe_studios", name: "TikTok", color: "#E1306C" },
  { icon: SiReddit, url: "https://www.reddit.com/user/TwinFrameStudios/", name: "Reddit", color: "#FF4500" },
  { icon: SiLinkedin, url: "https://linkedin.com/company/twinframestudios", name: "LinkedIn", color: "#0077B5" },
 // { icon: SiKickstarter, url: "https://www.kickstarter.com/profile/2032426606", name: "Kickstarter", color: "#05ce78" },
];

const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden py-10 px-8 md:px-24 text-white/45 text-sm"
      style={{ background: themeColors.footerBg }}
    >
      <div className="absolute inset-0 tf-noise opacity-[0.05]" />
      <div className="relative z-10">
      <div className="flex justify-center mb-6 flex-wrap gap-4">
        {socialLinks.map(({ icon: Icon, url, name }, index) => (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={name}
            className="w-11 h-11 rounded-full flex items-center justify-center bg-white/10 border border-white/10 hover:bg-white/20 hover:border-white/20 transition-all"
          >
           <Icon
  className="text-white text-[20px] transition-colors duration-300"
  style={{ color: undefined }}
  onMouseEnter={(e) => (e.currentTarget.style.color = socialLinks[index].color)}
  onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
/>
          </a>
        ))}
      </div>
      <p className="text-center">
        &copy; {new Date().getFullYear()} <BrandName />. All rights reserved.
      </p>
      </div>
    </footer>
  );
};

export default Footer;
